import { render, staticRenderFns } from "./PlanButton.vue?vue&type=template&id=03e80320&"
import script from "./PlanButton.vue?vue&type=script&lang=ts&"
export * from "./PlanButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports